import TrafficIcon from '@mui/icons-material/Traffic';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import DoneIcon from '@mui/icons-material/Done';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SkateboardingIcon from '@mui/icons-material/Skateboarding';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import ElectricBoltIcon from '@mui/icons-material/ElectricBolt';
import ErrorIcon from '@mui/icons-material/Error';
import SportsScoreIcon from '@mui/icons-material/SportsScore';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import PauseIcon from '@mui/icons-material/Pause';
import HelpIcon from '@mui/icons-material/Help';
import PhonelinkOffIcon from '@mui/icons-material/PhonelinkOff';
import BuildIcon from '@mui/icons-material/Build';

interface TicketStatusIconProps {
    icon: string | null;
    style?: React.CSSProperties;
}

export default function TicketStatusIcon(props: TicketStatusIconProps) {
    const { icon, style } = props;
    switch (icon) {
        case 'Traffic':
            return <TrafficIcon style={{ ...style }} />;
        case 'DoNotDisturb':
            return <DoNotDisturbIcon style={{ ...style }} />;
        case 'Done':
            return <DoneIcon style={{ ...style }} />;
        case 'DoneOutline':
            return <DoneOutlineIcon style={{ ...style }} />;
        case 'DoubleArrow':
            return <DoubleArrowIcon style={{ ...style }} />;
        case 'EmojiEvents':
            return <EmojiEventsIcon style={{ ...style }} />;
        case 'Skateboarding':
            return <SkateboardingIcon style={{ ...style }} />;
        case 'DirectionsRun':
            return <DirectionsRunIcon style={{ ...style }} />;
        case 'ElectricBolt':
            return <ElectricBoltIcon style={{ ...style }} />;
        case 'SportsScore':
            return <SportsScoreIcon style={{ ...style }} />;
        case 'Error':
            return <ErrorIcon style={{ ...style }} />;
        case 'SwapVert':
            return <SwapVertIcon style={{ ...style }} />;
        case 'CalendarMonth':
            return <CalendarMonthIcon style={{ ...style }} />;
        case 'CalendarToday':
            return <CalendarTodayIcon style={{ ...style }} />;
        case 'PauseCircleFilled':
            return <PauseCircleFilledIcon style={{ ...style }} />;
        case 'Pause':
            return <PauseIcon style={{ ...style }} />;
        case 'Help':
            return <HelpIcon style={{ ...style }} />;
        case 'PhonelinkOff':
            return <PhonelinkOffIcon style={{ ...style }} />;
        case 'Build':
            return <BuildIcon style={{ ...style }} />;
        default:
            return null;
    }
}